import { isRouteErrorResponse, useRouteError } from "react-router-dom";

const IMPORT_ERROR_FRAGMENTS = [
  "failed to fetch dynamically imported module",
  "error loading dynamically imported module",
  "importing a module script failed",
  "chunkloaderror",
];

const getErrorMessage = (error: unknown) => {
  if (isRouteErrorResponse(error)) {
    const responseMessage = typeof error.data === "string" ? error.data : error.statusText;

    return responseMessage || `Request failed with ${error.status}`;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return "Please reload the app and try again.";
};

const isStaleAppError = (message: string) => {
  const normalizedMessage = message.toLowerCase();

  return IMPORT_ERROR_FRAGMENTS.some((fragment) => normalizedMessage.includes(fragment));
};

const RouteErrorFallback = () => {
  const error = useRouteError();
  const message = getErrorMessage(error);
  const staleAppError = isStaleAppError(message);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        padding: "24px",
        background: "#f6f7fb",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "460px",
          padding: "32px",
          borderRadius: "20px",
          background: "#ffffff",
          boxShadow: "0 18px 45px rgba(15, 23, 42, 0.08)",
          textAlign: "center",
        }}
      >
        <h1
          style={{
            margin: "0 0 12px",
            fontSize: "28px",
            color: "#111827",
          }}
        >
          {staleAppError ? "A new version is ready" : "Something went wrong"}
        </h1>
        <p
          style={{
            margin: "0 0 24px",
            lineHeight: 1.6,
            color: "#4b5563",
          }}
        >
          {staleAppError
            ? "This tab is using an older build of the app. Reload once to open the latest version."
            : message}
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            border: "none",
            borderRadius: "999px",
            padding: "12px 22px",
            background: "#111827",
            color: "#ffffff",
            cursor: "pointer",
            fontSize: "15px",
            fontWeight: 600,
          }}
        >
          Reload app
        </button>
      </div>
    </div>
  );
};

export default RouteErrorFallback;
